import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsCustomerPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    toolTipLabel?: TypographyPresentationProps;
    toolTip?: InjectableCss;
}

export const customerPartNumberStyles: ProductDetailsCustomerPartNumberStyles = {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: 5px;
            @media (max-width: 1199px) and (min-width: 992px) {
                display: block;
            }
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: 5px;
        `,
    },
    toolTipLabel: {
        css: css`
            visibility: hidden;
            width: 130px;
            background-color: #363636;
            color: #fff;
            text-align: center;
            padding: 12px;
            position: absolute;
            z-index: 1;
            top: 35px;
            text-align: inherit;
            p {
                height: 1px;
            }

            &::after {
                content: "";
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -15px;
                border-width: 17px;
                border-style: solid;
                transform: rotate(180deg);
                top: -32px;
                border-color: #363636 transparent transparent transparent;
            }
        `,
    },
    toolTip: {
        css: css`
            cursor: pointer;
            margin-left: 10px;
            position: relative;
            display: flex;
            justify-content: center;
            color: #1E75BA;
            font-size: 13px;
            font-weight: 500;
            &:hover {
                span {
                    visibility: visible;
                    z-index: 2;
                }
            }
        `,
    },
};

const styles = customerPartNumberStyles;

const ProductDetailsCustomerPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.customerProductNumber) {
        return null;
    }

    const splitCustomerProductNumber = product.customerProductNumber?.split(',') || [""];

    return (
        <Typography {...styles.valueText} as="p" data-test-selector="customerProductNumber">
            <Typography {...styles.labelText}>{translate("PART #")}</Typography>
            {splitCustomerProductNumber[0]}
            {splitCustomerProductNumber[1] && 
                <StyledWrapper {...styles.toolTip}>
                    Show More
                    <Typography data-test-selector="tool-Tip-Label" {...styles.toolTipLabel}>
                    <ul data-test-selector="customerProductNumber">
                        {splitCustomerProductNumber.slice(1).map((part,index) => (
                            <li key={index}>
                                {part}
                            </li>
                        ))}
                    </ul>
                    </Typography>
                </StyledWrapper>
                }
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCustomerPartNumber),
    definition: {
        displayName: "Customer Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
